import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import './style.css'
import Navbar from '../common/Navbar'
import { handleLoginSubmit, handleValidateLogin } from '../../services/LoginService';
import { Helmet } from "react-helmet";
import LoginBox from './LoginFormComponent';
import SelectingUser from '../user/SelectionComponent';
import { BASE_IMG, DEFAULT_REDIRECT_ROUTE, LOGO_LOGIN_MAIN, BRAND_NAME, LOGO_LOGIN_TEXT, BRAND_TAGLINE } from '../../constants';
import { showErrorMessage, showLoader, showSuccessMessage } from '../../utils';
import { fetchData } from '../../services/HomeService';

export default function LoginComponent() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [showForgotPasswordLink, setShowForgotPasswordLink] = useState(false);
    const [allValues, setAllValues]  = useState({
        orgType: '',
        verified: false,
        displayType: 'login',
        step: 'email',
    })
    
    useEffect(() => {
        const checkSessionAndSkipLogin = async () => {
            try {
                const resp = await fetchData('/users/session/status');
                if (!resp?.success) return;

                const validateResp = await handleValidateLogin();
                if (!validateResp?.success) return;

                const { verified = false, org_type = '', step = 'email' } = validateResp.data || {};
                const params = new URLSearchParams({
                    step,
                    org_type,
                    verified,
                });

                if (org_type && verified && step) {
                    navigate(`${DEFAULT_REDIRECT_ROUTE}?${params.toString()}`);
                } else {
                    setAllValues((prev) => ({
                        ...prev,
                        displayType: 'selection',
                        orgType: org_type,
                        verified,
                        step,
                    }));
                }
            } catch (error) {
                console.error('Session check failed:', error);
            }
        };
        checkSessionAndSkipLogin();
    }, [navigate]);

    const handleLogin = async (e, authType, username, password) => {
        if (authType === 'local' && (!username || !password)) {
            showErrorMessage('Enter email and password');
            return;
        }
        setIsLoading(true);
        const { success, data={} , message='' } = await handleLoginSubmit(e, authType, username, password);
        if (success) {
            navigate(`${DEFAULT_REDIRECT_ROUTE}?${new URLSearchParams(data).toString()}`);
            showSuccessMessage(data.message || 'Logged in successfully');
        } else {
            showErrorMessage(message || 'Invalid email or password');
            if (authType === 'local') {
                setShowForgotPasswordLink(true);
            }
        }
        setIsLoading(false);
    }

    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        setAllValues({
            ...allValues, 
            step: queryParams.get('step'),
            orgType: queryParams.get('org_type'), 
            verified: queryParams.get('verified'),
            displayType: queryParams.get('type'), 
        })
    }, []);

    return (<>
        <Helmet>
            <title>{BRAND_NAME}- Login</title>
            <meta name="description" content="Securely log in to your account for personalized access and exclusive features. Streamline your interactions and manage your profile effortlessly" />
            <link rel="canonical" href="/login" />
        </Helmet>

        <div>
            <Navbar showSettings={false} />
            <div className="login">
                <div className="left-container">
                    <img src={`${BASE_IMG}/login_left.svg`} height="95%" width="95%" />
                </div>
                <div className="right-container">
                    <div className='right-subContainer auth-page-container'>
                        <div className="app-title-logo">
                            <div className="app-logo">
                                <img src={LOGO_LOGIN_MAIN} height="100%" width="100%" />
                            </div>
                            {LOGO_LOGIN_TEXT ? <div className="app-title">
                                <img src={LOGO_LOGIN_TEXT} />
                            </div>: null}
                        </div>
                        <div className="app-motto-text">{BRAND_TAGLINE}</div>
                        {allValues.displayType === 'selection' ? (
                            <SelectingUser orgType={allValues.orgType} verified={allValues.verified} step={allValues.step}/>
                        ) : (
                            <LoginBox
                                handleLogin={handleLogin}
                                showForgotPasswordLink={showForgotPasswordLink}
                            />
                        )}

                        <p className="login-bottom-text-container-bottom auth-page-footer">&copy; Copyright 2026 RazeHQ. All rights reserved.</p>
                    </div>
                </div>
            </div>
            {isLoading && showLoader("Logging")} 
        </div>
    </>
    );
}

